import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPayouts, requestPayout, updatePayout } from "./payoutsApi";

export const fetchPayoutsThunk = createAsyncThunk(
    "payouts/fetchPayouts",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await fetchPayouts(payload);
            return res;
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Failed to fetch payouts");
        }
    }
);

export const requestPayoutThunk = createAsyncThunk(
    "payouts/requestPayout",
    async (payload, { rejectWithValue }) => {
        try {
            await requestPayout(payload);
            return payload;
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Failed to request payout");
        }
    }
);

export const updatePayoutThunk = createAsyncThunk(
    "payouts/updatePayout",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            return await updatePayout(id, payload);
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Failed to update payout");
        }
    }
);
